import api from "./api";
import { parseListPayload, extractAssignmentSummary } from "utils/paginationStats";

function authHeaders() {
  const token = localStorage.getItem("tk446655440000");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const EMPTY_ASSIGNMENT_FILTERS = {
  search: "",
  regNumber: "",
  isTeacher: "",
  status: "",
  provinceId: "",
  departmentId: "",
  subPrefectureId: "",
  establishmentId: "",
};

export const ASSIGNMENT_LIST_FILTER_KEYS = [
  "search",
  "regNumber",
  "isTeacher",
  "status",
  "provinceId",
  "departmentId",
  "subPrefectureId",
  "establishmentId",
];

const NUMERIC_FILTER_KEYS = new Set([
  "provinceId",
  "departmentId",
  "subPrefectureId",
  "establishmentId",
]);

/** Build query params for GET /Assignment/summary */
export function buildAssignmentListParams({ pageNumber = 1, pageSize = 10, filters = {} } = {}) {
  const params = { pageNumber, pageSize };

  ASSIGNMENT_LIST_FILTER_KEYS.forEach((key) => {
    const raw = filters[key];
    if (raw === "" || raw == null) return;
    if (key === "isTeacher") {
      if (raw === true || raw === "true") params.isTeacher = true;
      else if (raw === false || raw === "false") params.isTeacher = false;
      return;
    }
    if (NUMERIC_FILTER_KEYS.has(key)) {
      const num = Number(raw);
      if (Number.isFinite(num) && num > 0) params[key] = num;
      return;
    }
    const value = String(raw).trim();
    if (value) params[key] = value;
  });

  return params;
}

export function normalizeAssignmentTeacherStatus(value) {
  if (value === true || value === 1) return "active";
  if (value === false || value === 0) return "inactive";
  const status = String(value ?? "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (["active", "actif", "enabled", "en poste"].includes(status)) return "active";
  if (["inactive", "inactif", "disabled", "deactivated", "desactive"].includes(status)) {
    return "inactive";
  }
  return status;
}

export function filterAssignmentTeacherOptions(options, { isTeacher = "", status = "" } = {}) {
  const requestedType = String(isTeacher ?? "");
  const requestedStatus = normalizeAssignmentTeacherStatus(status);
  return (options || []).filter((option) => {
    if (requestedType && String(option.isTeacher ?? "") !== requestedType) return false;
    if (
      requestedStatus &&
      normalizeAssignmentTeacherStatus(option.status) !== requestedStatus
    ) {
      return false;
    }
    return true;
  });
}

export function parseAssignmentListResponse(data) {
  const rows = parseListPayload(data);
  const stats = extractAssignmentSummary(rows, data);
  return {
    rows,
    stats,
    activeFilters: data?.Stats?.Filters ?? data?.stats?.filters ?? null,
  };
}

export async function fetchAssignmentList({ pageNumber, pageSize, filters }) {
  const params = buildAssignmentListParams({ pageNumber, pageSize, filters });
  const res = await api.get("/Assignment/summary", { params, headers: authHeaders() });
  return parseAssignmentListResponse(res.data);
}
